import React from "react";
import ViewerFallback from "@/components/ViewerFallback";

type Props = {
    children: React.ReactNode;
    fallbackTitle?: string;
    fallbackMessage?: string;
    testId?: string;
};

type State = { hasError: boolean; message?: string };

/**
 * Fängt Render-Zeit-Fehler in Video-/Photo-Viewer ab, damit die rote CRA-
 * Uncaught-Runtime-Error-Overlay nie erscheint. Zeigt stattdessen die
 * HypeFly-Fallback-Karte.
 */
export default class ViewerErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(err: Error): State {
        return { hasError: true, message: err.message };
    }

    componentDidCatch(err: Error, info: React.ErrorInfo) {
        console.warn(
            "[ViewerErrorBoundary] caught",
            err.message,
            info.componentStack,
        );
    }

    render() {
        if (this.state.hasError) {
            return (
                <ViewerFallback
                    testId={this.props.testId || "viewer-fallback"}
                    title={this.props.fallbackTitle}
                    message={this.props.fallbackMessage}
                />
            );
        }
        return this.props.children;
    }
}
